import React from 'react'
import { Helmet } from 'react-helmet'
import { Redirect } from 'react-router'
import classNames from 'classnames'
import { get404Url } from 'mobile_web/modules/navigation/routes'

import classnames from 'classnames'

import {
	BundleOffer,
	Collection,
	CollectionTourContainer as Container,
	isCollectionBundleLocked,
	offeredBundlesFor,
} from 'mytours-read-common'
import {
	GetAppShowResponse,
	GetCollectionItemsIndexResponseData,
	GetCollectionsShowResponse,
	RedeemCode,
} from 'mytours-read-api-typescript'

import { CollectionListNavigationProps } from '../types'
import { layoutMode, stopHash, stopIdFromHash, stopsToPrioritize, webDownloadPolicy } from '../functions'
import CollectionTourStopList from './CollectionTourStopList'
import TourDownload from './TourDownload'
import { activeDownload, collectionKey } from 'mobile_web/modules/offline'

import { getStyleProperty, getDirMode, format } from '../../platform'
import Page from '../../common/components/Page'
import { getImageAlt, getPageContainer, loadingTimeout } from '../../common/functions'
import { Button, Footer, Text, Grid, GridRow, GridCol } from '@mytours/components'
import Modal from '../../common/components/modal'
import { ImageSizePreset } from '../../../common_lib/types'
import { generateImageSrcSet, generateImageUrl, getScreenSize } from '../../../common_lib/utils'
import { ScreenSize, ScreenSizeBreakpoints } from 'common_lib/types'
import { formatCurrency, validateCollectionCode } from 'mobile_web/modules/lockapp/functions'
import ScrollbarListener from 'mobile_web/modules/common/components/scrollbar-listener'
import { fade } from 'common_lib/services/color'

import Header from 'mobile_web/modules/common/components/header'
import SinglePageTourDownload from './SinglePageTourDownload'
import TourDownloadedChip from './TourDownloadedChip'
import SinglePageTourMap from './SinglePageTourMap'
import { ionHistory } from '../../navigation'

import ImagePlaceholder from '../../common/components/placeholders/Image'
import TextPlaceholder from 'mobile_web/modules/common/components/placeholders/Text'

import strings from '../../../strings'

import './styles/tour.less'
import ErrorMessageHandler from 'mobile_web/modules/common/components/error-message-handler'
import { DEFAULT_APP_INFO, loadAppMetaDataFromDisk } from 'mobile_web/modules/settings/functions'
import SectionMediaAudioComponent from 'mobile_web/modules/screen/components/parts/SectionMediaAudio'
import AudioPlayerBarComponent from 'mobile_web/modules/audio/components/AudioPlayerBar'
import ForeignAudioPlayerBar from './ForeignAudioPlayerBar'
import LockAppComponent from 'mobile_web/modules/lockapp/components/LockApp'
import BundleUnlockButton from 'mobile_web/modules/lockapp/components/BundleUnlockButton'

interface OwnProps {
	isInsideModal?: boolean
}

type Props = Container.Props & Container.Actions & CollectionListNavigationProps & OwnProps

interface State {
	imageWidth: number
	imageHeight: number
	screenSize: ScreenSize
	showLockModal: boolean
	codeLock: boolean
	hasWebPrice: boolean
	openPayModalImmediately: boolean
	loading: boolean
	distanceUnit: GetAppShowResponse.DistanceUnitEnum
	openStopId: string | null
}

class CollectionTour extends React.Component<Props, State> {
	itemVersion = 0
	collectionDetailsLoading = false
	tourLoading = false

	footerRef = React.createRef<HTMLElement>()

	private unlistenHistory?: () => void

	constructor(props: Props) {
		super(props)

		const screenSize = getScreenSize()

		this.state = {
			...this.getImageDimensions(screenSize),
			screenSize,
			showLockModal: false,
			codeLock: null,
			hasWebPrice: null,
			openPayModalImmediately: false,
			loading: this.props.loading,
			distanceUnit: null,
			openStopId: stopIdFromHash(ionHistory.location.hash),
		}
	}

	private isSinglePage = (): boolean => layoutMode(this.props.item?.initial_layout) === 'singlePage'

	// The single page layout previews each stop's leading screen section, so it asks for the whole tour
	// in one response. The other two layouts must not pay for it — it carries every screen in the tour.
	private downloadTourStops = (): void => {
		const { collectionVersion, language, accountId } = this.props

		this.props.downloadTour(collectionVersion, language, accountId, this.isSinglePage())
	}

	componentDidUpdate(prevProps: Container.Props): void {
		const {
			language,
			collectionId,
			collectionVersion,
			accountId,
			hasLoadedStops,
			isLoadingStops,
			item,
			validateCode,
			loading,
			unlockedViaBundle,
		} = this.props

		if (collectionVersion) {
			if (
				(!this.collectionDetailsLoading && language !== prevProps.language) ||
				collectionId !== prevProps.collectionId ||
				!item
			) {
				this.props.loadCollectionDetails(collectionVersion, language, accountId)
				this.collectionDetailsLoading = true
			}

			if (!this.tourLoading && ((!hasLoadedStops && !isLoadingStops) || collectionId !== prevProps.collectionId)) {
				this.downloadTourStops()
				this.tourLoading = true
			} else if (item && item.version != this.itemVersion) {
				this.itemVersion = item.version
				this.downloadTourStops()
			} else if (item) {
				this.tourLoading = false
				this.collectionDetailsLoading = false
			}
		}

		if (
			(this.state.codeLock === null && item?.hasOwnProperty('code_lock')) ||
			(this.state.hasWebPrice === null && item?.pricing?.web_price?.amount)
		) {
			// A collection inside a redeemed bundle is unlocked regardless of its own code/price gate.
			const codeLock = item.code_lock && !unlockedViaBundle
			const hasWebPrice = !!item.pricing?.active && !!item.pricing?.web_price?.amount && !unlockedViaBundle
			this.setState({ codeLock, hasWebPrice }, async () => {
				if (codeLock || hasWebPrice) await validateCollectionCode(item, validateCode)

				if (hasWebPrice) {
					const url = new URL(window.location.href)
					const searchParams = url.searchParams
					const orderId = Number(searchParams.get('order-id'))
					// Open modal and check if the payment was successful
					if (orderId) {
						this.setState({ showLockModal: true })
					}
				}
			})
		}

		if (prevProps.loading !== loading) {
			// loading with timeout to change skeleton with images content smoothly
			loadingTimeout(loading, val => this.setState({ loading: val }))
		}

		this.checkUnlockApp(prevProps)

		// If a bundle redemption unlocks this collection after its own lock was already applied,
		// clear the gate so the tour becomes accessible without a collection code.
		if (unlockedViaBundle && (this.state.codeLock || this.state.hasWebPrice)) {
			this.setState({ codeLock: false, hasWebPrice: false, showLockModal: false })
		}
	}

	componentDidMount(): void {
		const { collectionVersion, accountId, language, loadCollectionDetails } = this.props
		if (collectionVersion) {
			loadCollectionDetails(collectionVersion, language, accountId)
		}

		this.setDistanceUnit()

		addEventListener('resize', this.setImgDimension)

		// oxlint-disable-next-line react/no-did-mount-set-state -- the listener fires on navigation, not during mount
		this.unlistenHistory = ionHistory.listen(({ hash }) => this.setState({ openStopId: stopIdFromHash(hash) }))
	}

	componentWillUnmount(): void {
		removeEventListener('resize', this.setImgDimension)

		this.unlistenHistory?.()
	}

	private setDistanceUnit = async (): Promise<void> => {
		const appData = await loadAppMetaDataFromDisk(DEFAULT_APP_INFO.projectId)

		this.setState({
			distanceUnit: appData?.distance_unit || null,
		})
	}

	getHeight = (width: number): number => width * 0.5625

	getImageDimensions = (screenSize: ScreenSize = getScreenSize()): Pick<State, 'imageHeight' | 'imageWidth'> => {
		let width = 0
		switch (screenSize) {
			case ScreenSize.lg:
			case ScreenSize.md: {
				width = ScreenSizeBreakpoints.lg
				break
			}
			case ScreenSize.sm: {
				width = ScreenSizeBreakpoints.md
				break
			}
			case ScreenSize.xs:
			default: {
				width = ScreenSizeBreakpoints.sm
				break
			}
		}
		return { imageHeight: this.getHeight(width), imageWidth: width }
	}

	private checkUnlockApp = (prevProps: Container.Props) => {
		const { lockCollection, item, validateCode } = this.props
		if (!lockCollection.loading && lockCollection.loaded) {
			if (lockCollection.status === 'valid' && !prevProps.lockCollection.status) {
				this.setState({ codeLock: false, hasWebPrice: false, showLockModal: false })
			} else if (
				(lockCollection.status === 'invalid' || lockCollection.status === 'expired') &&
				!prevProps.lockCollection.status
			) {
				validateCollectionCode(item, validateCode)
			}
		}
	}

	setImgDimension = (): void => {
		const { screenSize: prevScreenSize } = this.state
		const screenSize = getScreenSize()

		if (screenSize !== prevScreenSize) {
			this.setState({ ...this.getImageDimensions(screenSize), screenSize })
		}
	}

	// The collection's own gate, and the bundles that also sell it. A bundle force-lock keeps the tour
	// shut even when the collection itself is free, so it has to gate the same places code_lock does.
	hasOwnLock = (): boolean => {
		const { item } = this.props
		const { codeLock, hasWebPrice } = this.state
		return !!((item?.code_lock && codeLock) || hasWebPrice)
	}

	isBundleLocked = (): boolean => {
		const { item, unlockedViaBundle, lockCollection } = this.props
		return isCollectionBundleLocked(item, unlockedViaBundle, lockCollection)
	}

	unlockingBundles = (): BundleOffer[] => {
		const { item } = this.props
		if (!item || (!this.hasOwnLock() && !this.isBundleLocked())) {
			return []
		}
		return offeredBundlesFor(item)
	}

	onTourButtonPressed = (): void => {
		const { hasLoadedStops, isLoadingStops, collectionVersion, accountId } = this.props

		if (this.hasOwnLock()) {
			this.setState({ showLockModal: true })
			return
		}

		// Unreachable while renderButtons offers the bundle instead of a button wired here; kept so the two
		// cannot disagree about what the lock means.
		if (this.isBundleLocked()) {
			return
		}

		if (collectionVersion) {
			// if tour is ready to start
			if (hasLoadedStops) {
				const tour = this.props.item
				const tourTitle = tour?.title || ''

				this.prioritizeDownload(null)
				this.props.navigateToTourStop(collectionVersion, tourTitle, accountId)
				if (this.props.onBackAction) {
					this.props.onBackAction({ closeMapModal: true })
				}
			} else if (isLoadingStops) {
				// do nothing
			} else {
				// download tour
				this.downloadTourStops()
			}
		}
	}

	onBuyButtonPressed = (): void => {
		this.setState({ showLockModal: true, openPayModalImmediately: true })
	}

	getTourDurationString = (): string => {
		const { item = {} as Collection } = this.props

		const minDurationString = format.duration(item.length_min) || ''
		const maxDurationString = format.duration(item.length_max) || ''

		return minDurationString && maxDurationString
			? `${minDurationString} - ${maxDurationString}`
			: minDurationString || maxDurationString || ''
	}

	getDistance = () => {
		const { item } = this.props
		const { distanceUnit } = this.state
		const distance = item?.distance

		if (!distance) {
			return null
		}

		return format.distance(distance, distanceUnit)
	}

	getTourTypeCustomIconName = (
		type: GetCollectionsShowResponse.TourTypeEnum,
		subtype: GetCollectionsShowResponse.TourSubtypeEnum,
	): string => {
		switch (type) {
			case GetCollectionsShowResponse.TourTypeEnum.Walking:
				return subtype ? `fa-ic-${subtype.replace(/\_/g, '-')}` : null
			case GetCollectionsShowResponse.TourTypeEnum.Cycling:
				return 'fa-ic-tour-type-bicycle'
			case GetCollectionsShowResponse.TourTypeEnum.Canoeing:
				return 'fa-ic-tour-type-canoe'
			case GetCollectionsShowResponse.TourTypeEnum.Driving:
				return 'fa-ic-tour-type-driving'
			case GetCollectionsShowResponse.TourTypeEnum._4wd:
				return 'fa-ic-tour-type-4wd'
			case GetCollectionsShowResponse.TourTypeEnum.HorseTrail:
				return 'fa-ic-tour-type-horse'
			case GetCollectionsShowResponse.TourTypeEnum.HistoricHouse:
				return 'fa-ic-tour-type-historic-house'
			case GetCollectionsShowResponse.TourTypeEnum.AboriginalSite:
				return 'fa-ic-tour-type-aboriginal'
			case GetCollectionsShowResponse.TourTypeEnum.Museum:
				return 'fa-ic-tour-type-museum'
			case GetCollectionsShowResponse.TourTypeEnum.Gallery:
				return 'fa-ic-tour-type-gallery'
			case GetCollectionsShowResponse.TourTypeEnum.Ship:
				return 'fa-ic-tour-type-ship'
			case GetCollectionsShowResponse.TourTypeEnum.Bus:
				return 'fa-ic-tour-type-bus'
			case GetCollectionsShowResponse.TourTypeEnum.Airplane:
				return 'fa-ic-tour-type-airplane'
			case GetCollectionsShowResponse.TourTypeEnum.Helicopter:
				return 'fa-ic-tour-type-helicopter'
			case GetCollectionsShowResponse.TourTypeEnum.NatureTrail:
				return 'fa-ic-tour-type-nature-trail'
			case GetCollectionsShowResponse.TourTypeEnum.Train:
				return 'fa-ic-tour-type-train'
		}

		return null
	}

	renderTourTypeIcon = () => {
		const { item = {} as Collection } = this.props

		const typeIconName = this.getTourTypeCustomIconName(item.tour_type, item.tour_subtype)

		if (typeIconName === null) {
			if (item.tour_type === GetCollectionsShowResponse.TourTypeEnum.Walking) {
				return (
					<>
						<i className="icon fas fa-walking" />
						<Text variant="inherit" className="label capitalize">
							{strings.tour_type_walking}
						</Text>
					</>
				)
			}
			if (item.tour_type === GetCollectionsShowResponse.TourTypeEnum.ScavengerHunt) {
				return (
					<>
						<i className="icon fas fa-search" />
						<Text variant="inherit" className="label capitalize">
							{strings.tour_type_scavenger_hunt}
						</Text>
					</>
				)
			}

			return undefined
		}

		return (
			<>
				<i className={classNames('icon', 'fak', typeIconName)} />
				{item?.tour_type && Object.values(GetCollectionsShowResponse.TourTypeEnum).includes(item.tour_type) ? (
					<Text variant="inherit" className="label capitalize">
						{strings[`tour_type_${item.tour_type}`]}
					</Text>
				) : null}
			</>
		)
	}

	renderLockContentModal = () => {
		const { item } = this.props

		if (!item) {
			return undefined
		}

		const { code_title: codeTitle, code_text: codeText, code_background_media_item: codeBackgroundMediaItem } = item
		const { showLockModal, hasWebPrice, openPayModalImmediately } = this.state
		return (
			<Modal
				isOpen={showLockModal}
				cssClass="page-modal lock-page-modal"
				onDidDismiss={() => {
					this.setState({ openPayModalImmediately: false, showLockModal: false })
				}}
				showBackdrop={false}
			>
				<LockAppComponent
					linkedId={item.id}
					linkedType={RedeemCode.LinkedTypeEnum.Collection}
					title={codeTitle}
					description={codeText}
					backgroundImage={codeBackgroundMediaItem}
					webPrice={hasWebPrice && item.pricing?.web_price}
					openPayModalImmediately={openPayModalImmediately}
				/>
			</Modal>
		)
	}

	renderTitle = (title: string): React.ReactNode => <h1 className="title">{title}</h1>

	renderTourInfoRow = (): React.ReactNode => {
		const { item = {} as Collection } = this.props

		const stopCount = item.stop_count
		const tourType = item.tour_type
		const durationText = this.getTourDurationString()
		const distanceText = this.getDistance()

		if (!stopCount && !tourType && !durationText && !distanceText) {
			return null
		}

		return (
			<GridRow className="tour-metadata">
				{stopCount ? (
					<GridCol className="data">
						<i className={classnames('icon', getDirMode(), 'fas fa-map-marker-alt')} />
						<Text variant="inherit" className="label">{`${stopCount} ${strings.stops}`}</Text>
					</GridCol>
				) : null}

				{tourType && <GridCol className="data">{this.renderTourTypeIcon()}</GridCol>}

				{durationText && (
					<GridCol className="data">
						<i className={classnames('icon', getDirMode(), 'fas fa-clock')} />
						<Text variant="inherit" className="label">
							{durationText}
						</Text>
					</GridCol>
				)}

				{distanceText && (
					<GridCol className="data">
						<i
							className={classNames(
								'icon',
								'fak',
								item.distance_loop ? 'fa-ic-tour-distance-return' : 'fa-ic-tour-distance-one-way',
							)}
						/>
						<Text variant="inherit" className="label">
							{distanceText}
						</Text>
					</GridCol>
				)}

				{/* Only this layout: every other one keeps a saved tour's check on the footer's download
				    button, and would say it twice. */}
				{this.isSinglePage() && item?.id ? (
					<TourDownloadedChip collectionId={item.id} language={this.props.language} />
				) : null}
			</GridRow>
		)
	}

	renderHeading = (): React.ReactNode => {
		const { item = {} as Collection } = this.props
		const { loading } = this.state

		return (
			<div className={classnames('tour-heading', { 'with-download': this.isSinglePage() })}>
				{loading ? (
					<TextPlaceholder />
				) : (
					<>
						{this.renderTitle(item.title)}
						{this.renderTourInfoRow()}
						{this.isSinglePage() && this.renderDownloadControl()}
					</>
				)}
			</div>
		)
	}

	renderAudioPreview = () => {
		const { item = {} as Collection } = this.props

		if (!item.audio_preview) {
			return undefined
		}

		return (
			<SectionMediaAudioComponent
				audioPreview={item.audio_preview}
				container={{ type: 'tour', id: item.id, title: item.name }}
				collectionId={item.id}
			/>
		)
	}

	renderTourDescription = () => {
		const { item = {} as Collection } = this.props
		const { loading } = this.state
		// Why can it be NaN?
		const margin = parseInt(getStyleProperty('--content-margin-horizontal')) || 0

		return (
			<GridRow
				className="description body-text"
				style={{
					paddingTop: 0,
					paddingBottom: 0,
					marginTop: margin,
					marginBottom: margin,
					paddingLeft: margin,
					paddingRight: margin,
				}}
			>
				{loading ? <TextPlaceholder width="60%" /> : <div dangerouslySetInnerHTML={{ __html: item.description }} />}
			</GridRow>
		)
	}

	renderContent = (): React.ReactNode => {
		const { item = {} as Collection, onBackAction, isInsideModal } = this.props
		const { loading } = this.state

		const { cover_image: coverImage } = item

		const imageUrl =
			coverImage?.file &&
			generateImageUrl(coverImage.file, {
				imageSizePreset: ImageSizePreset.Row,
			})
		const imageSrcSet =
			coverImage?.file &&
			generateImageSrcSet(coverImage.file, {
				imageSizePreset: ImageSizePreset.Row,
			})

		const headerProps = {
			title: strings.tour_details_title,
			onBackButton: onBackAction,
			hideBackButton: isInsideModal,
			showBackButton: Boolean(onBackAction),
			hideTitle: true,
			isTransparentHeader: true,
			screen: null,
			collection: item,
			collectionItem: null,
			hideFavouriteButton: false,
			itemId: item.id,
			itemType: GetCollectionItemsIndexResponseData.ItemTypeEnum.Collection,
		}

		return (
			<>
				{/* The single page's header carries a map button, and the map opens over the page rather than
				    navigating away from it — so the two travel together, in a component that can hold the hook
				    this class cannot. */}
				{this.isSinglePage() ? (
					<SinglePageTourMap
						collection={item}
						collectionItems={this.props.collectionItems}
						loading={loading}
						openStopId={this.state.openStopId}
						onOpenStopChange={this.openStop}
						headerProps={headerProps}
					/>
				) : (
					<Header {...headerProps} />
				)}
				{(imageUrl || loading) && (
					<div className="cover-img-wrapper">
						{loading ? (
							<ImagePlaceholder className="cover-img" />
						) : (
							<img src={imageUrl} srcSet={imageSrcSet} className="cover-img" alt={getImageAlt(coverImage)} />
						)}
					</div>
				)}

				<Grid className="tour-content">
					{this.renderHeading()}
					<div className="content">
						{this.renderAudioPreview()}
						{this.renderTourDescription()}
					</div>
				</Grid>
				{this.isSinglePage() && this.renderStopList()}
				{/* Render footer outside of `tour-content` so that */}
				{/* the background span the whole width (require when using app backgroundimage) */}
				{this.renderFooter()}
			</>
		)
	}

	// The open stop lives on the URL, so a shared link, a QR scan and the back button all reach the same
	// row, and it survives whatever else the page opens over it. State follows from the history listener
	// rather than being set here, so the two cannot disagree about which stop is open.
	//
	// One entry is pushed for the whole reading — opening the first stop — and every move after it
	// replaces. Back therefore leaves the page rather than walking back down the stops the reader passed
	// through, and closing a row is the same round trip the map modal already makes.
	private openStop = (openStopId: string | null): void => {
		this.prioritizeDownload(openStopId)

		const { pathname, search } = ionHistory.location
		const url = `${pathname}${search}${openStopId === null ? '' : stopHash(openStopId)}`

		if (openStopId !== null && this.state.openStopId === null) {
			ionHistory.push(url)
		} else {
			ionHistory.replace(url)
		}
	}

	/**
	 * Keep the visitor behind the downloader. A download in flight re-orders itself around the stop just
	 * opened; with none in flight there is nothing to re-order, and the tour streams as it always has.
	 */
	private prioritizeDownload = (fromStopId: string | null): void => {
		const { item, collectionItems } = this.props
		if (!item?.id) return

		activeDownload(collectionKey(item.id))?.prioritizeStops(stopsToPrioritize(collectionItems, fromStopId))
	}

	// The locks come first, exactly as they do for the footer's buttons: downloading is what you do once
	// you are past them. Waiting for the stops keeps the offer off a page that has none to save yet, and
	// costs a forced download nothing — it fetches its own manifest anyway. Rendered from the heading
	// because that is where the collapsed circle sits; the pill floats and takes its position from CSS.
	renderDownloadControl = (): React.ReactNode => {
		const { hasLoadedStops, item, language } = this.props
		if (!hasLoadedStops || this.hasOwnLock() || this.isBundleLocked()) {
			return null
		}

		const policy = webDownloadPolicy(item?.allow_download)
		if (policy === 'off') {
			return null
		}

		return (
			<SinglePageTourDownload
				collectionId={item.id}
				policy={policy}
				fileSize={item?.file_size}
				language={language}
				title={item?.title}
			/>
		)
	}

	renderStopList = (): React.ReactNode => {
		const { collectionItems, isLoadingStops, errorLoadingStops, item } = this.props

		return (
			<CollectionTourStopList
				collectionItems={collectionItems}
				collectionId={item.id}
				isLoadingStops={isLoadingStops}
				errorLoadingStops={errorLoadingStops}
				openStopId={this.state.openStopId}
				onOpenStopChange={this.openStop}
			/>
		)
	}

	renderFooter = (): React.ReactNode => {
		const { item = {} as Collection, isInsideModal } = this.props
		const { loading } = this.state

		if (loading) return

		const buttons = this.renderButtons()
		const bgColor = getStyleProperty('--background-color')

		const beforeBackgroundImage = `linear-gradient(180deg,
			${fade(bgColor, 0)} 0,
			${fade(bgColor, 0.07407407)} 4.49%,
			${fade(bgColor, 0.25925926)} 16.59%,
			${fade(bgColor, 0.5)} 34.25%,
			${fade(bgColor, 0.74074074)} 55.41%,
			${fade(bgColor, 0.92592593)} 78.01%,
			${bgColor})`

		return (
			<ScrollbarListener element={getPageContainer(this.footerRef?.current)}>
				{scrollbarWidth => (
					<Footer className="tour-footer" style={{ paddingInlineEnd: scrollbarWidth }} ref={this.footerRef}>
						{/* The single page layout has no footer button: its stops are already on the page. */}
						{item?.item_count > 0 && !this.isSinglePage() && buttons ? (
							<div className="start-tour-content">
								<div className="start-tour-before" style={{ background: beforeBackgroundImage }} />
								<div className="tour-content">
									<div className="start-tour-buttons">{buttons}</div>
								</div>
							</div>
						) : null}
						{/* The single page layout plays its own audio through the pills and the open row's
						    transport, so its bar is only for a track that belongs to no stop here — see
						    ForeignAudioPlayerBar. Every other layout has no pills, so the bar is all there is. */}
						{!isInsideModal &&
							(this.isSinglePage() ? (
								<ForeignAudioPlayerBar collectionId={item?.id} collectionItems={this.props.collectionItems} />
							) : (
								<AudioPlayerBarComponent />
							))}
					</Footer>
				)}
			</ScrollbarListener>
		)
	}

	renderButtons = () => {
		const { hasLoadedStops, isLoadingStops, item } = this.props
		const { hasWebPrice } = this.state

		// The gate comes before anything about stops: downloading is what you do once you are past it, so a
		// locked tour offers the way in at every stage of loading, not only once the stops have arrived.
		if (this.hasOwnLock()) {
			const webPrice = hasWebPrice ? item?.pricing?.web_price : undefined
			const price = webPrice ? formatCurrency(webPrice.currency, webPrice.amount) : ''
			const buyButtonText = strings.formatString(strings.buy_for, { price }) as string
			return (
				<>
					<Button variant="clear" onClick={this.onTourButtonPressed} aria-label={strings.enter_code} className="btn">
						{strings.enter_code}
					</Button>
					{webPrice && (
						<Button variant="clear" onClick={this.onBuyButtonPressed} aria-label={buyButtonText} className="btn">
							{buyButtonText}
						</Button>
					)}
					<BundleUnlockButton
						bundles={this.unlockingBundles()}
						accountId={item?.account_id}
						className="btn bundle-btn"
					/>
				</>
			)
		}

		// A bundle-locked tour with nothing to offer would be a footer bar with no button in it, so
		// renderFooter drops the bar instead of painting an empty one.
		if (this.isBundleLocked()) {
			const bundles = this.unlockingBundles()
			if (bundles.length === 0) {
				return null
			}

			return <BundleUnlockButton bundles={bundles} accountId={item?.account_id} className="btn" />
		}

		if (hasLoadedStops) {
			const startButton = (
				<Button
					variant="clear"
					onClick={this.onTourButtonPressed}
					aria-label={strings.start_tour}
					className="btn start-btn"
				>
					{strings.start_tour}
				</Button>
			)

			// The tour's own policy decides whether a download is offered at all, and whether it insists.
			// Downloading is what you do once past the gates above, so this comes after them.
			const policy = webDownloadPolicy(item?.allow_download)
			if (policy === 'off') {
				return startButton
			}

			return (
				<TourDownload
					collectionId={item.id}
					policy={policy}
					fileSize={item?.file_size}
					language={this.props.language}
					title={item?.title}
					startButton={startButton}
				/>
			)
		}

		const buttonText = isLoadingStops ? strings.loading_tour : strings.load_tour
		return (
			<Button variant="clear" onClick={this.onTourButtonPressed} aria-label={buttonText} className="btn">
				{buttonText}
			</Button>
		)
	}

	render() {
		const { error, item = {} as Collection, isInsideModal } = this.props

		const { title, description, cover_image: coverImage } = item

		let imageUrl: string | null = null
		if (coverImage?.file) {
			imageUrl = generateImageUrl(coverImage.file, {
				imageSizePreset: ImageSizePreset.Row,
			})
		}

		if (!item || error?.status === 404) {
			return <Redirect to={get404Url()} />
		}

		return (
			<>
				<Helmet
					title={title}
					meta={[
						{ name: 'description', content: description || title },
						{ property: 'og:type', content: 'website' }, // TODO: check type
						{ property: 'og:title', content: title },
						{ property: 'og:description', content: description || title },
						{ property: 'og:image', content: imageUrl },
						{ property: 'og:url', content: window.location.href },
					]}
				/>

				<Page
					contentProps={{
						className: classNames('collection-tour', { 'single-page': this.isSinglePage() }),
					}}
					dataItemId={String(item.id)}
					dataItemType="collection"
					dataItemSubtype="tour"
					dataCy="page-collection-tour"
				>
					<ErrorMessageHandler error={error} />
					{!error && item && <>{this.renderContent()}</>}
				</Page>
				{!(!error && item) && !isInsideModal && <AudioPlayerBarComponent />}
				{this.renderLockContentModal()}
			</>
		)
	}
}

const CollectionTourComponent = Container.default(CollectionTour)
export default CollectionTourComponent as any
